<div class="newUserDiv">
  <form [formGroup]="addNewUserForm" autocomplete="off">
    <div class="row">
      <div class="col-sm-12 col-md-12 headerText">
        {{newUserTxt.pageTitleLbl?newUserTxt.pageTitleLbl:newUserDialog.pageTitleLbl}}
        <p style="font-size: 10px;">
          If you are experiencing login trouble for an existing account, please use the Forgot Password or Forgot Username link in the Sign In box and ensure you are entering the email address associated to your KawneerDirect account.
          If your account is inactive, please email KawneerDirect&#64;kawneer.atlassian.net for assistance.
          New account requests will not be approved if account already exists for same customer employee.
        </p>
      </div>
      <br />
      <br />
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label class="lblCls">
            {{newUserTxt.userNameLbl?newUserTxt.userNameLbl:newUserDialog.userNameLbl}}<span class="requiredField">*</span>
          </label>
          <div class="input-wrapper">
            <kendo-textbox class="form-control" formControlName="userName" autofocus
                           [ngClass]="{'borderRed':newUserDialog.isEmptyUserName ||newUserDialog.showUserNameIcon}"
                           (keyup)="checkUserNameAvailable()"></kendo-textbox>
            <span id="icon_move" class="k-icon k-i-info" kendoTooltip title="{{newUserDialog.usernameNoteTooltip}}"></span>
            <!--<span title="" *ngIf="newUserDialog.isNotExistUserNameIcon" kendoTooltip
          class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"></span>
    <span title="Username is not available" *ngIf="newUserDialog.isExistUserNameIcon" kendoTooltip
          class="k-icon k-i-close-circle k-i-x-circle"></span>-->


           
            </div>
          <div>
            <span title="{{isUserNameVal}}"
                  *ngIf="(newUserDialog.showUserNameIcon)" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>

            <span class="k-icon k-i-loading" *ngIf="newUserDialog.userNameProcessing"></span>
            <span class="k-icon k-i-check-circle k-i-checkmark-circle spanInfoIconCls"
                  *ngIf="newUserDialog.isUserNameValid"
                  style="color:green;font-weight:600"></span>
          </div>
          </div>
          <!--<div class="form-group">
    <label class="lblCls">
      {{newUserTxt.passwordLbl?newUserTxt.passwordLbl:newUserDialog?.passwordLbl}}<span class="requiredField">*</span>
    </label>
    <input type="password" kendoTextBox class="form-control"
           (blur)="validateNewUserForm()"
           [ngClass]="{'borderRed':newUserDialog?.isInvalidPassword && newUserDialog?.isSubmitted}"
           formControlName="password" />
  </div>-->
          <div class="form-group">
            <label class="lblCls">
              {{newUserTxt.firstNameLbl?newUserTxt.firstNameLbl:newUserDialog.firstNameLbl}}<span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="firstName"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidFirstName && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{newUserTxt.lastNameLbl?newUserTxt.lastNameLbl:newUserDialog.lastNameLbl}}<span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="lastName"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidLastName && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{newUserTxt.phoneNumberLabel?newUserTxt.phoneNumberLabel:newUserDialog.phoneNumberLbl}}<span class="requiredField">*</span>
            </label>
            <kendo-numerictextbox class="kendoInput" name="phoneNumber" formControlName="phoneNumber" [decimals]="0"
                                  [format]="'#'" [spinners]="false" [stopWheel]="true"
                                  [ngClass]="{'borderRed':newUserDialog.isInvalidPhoneNumber && newUserDialog.isSubmitted}"
                                  maxlength="10" (blur)="validateNewUserForm()"></kendo-numerictextbox>
            <span title="{{newUserTxt.invalidPhoneLbl?newUserTxt.invalidPhoneLbl:newUserDialog.invalidPhoneLbl}}"
                  *ngIf="newUserDialog.isInvalidPhoneNumberMessage" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
          </div>
          <label class="lblCls">
            <b>Billing Address</b>
          </label>
          <div class="form-group">
            <label class="lblCls">
              Street1 Address<span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="billingStreet1Address"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidStreet1Address && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              Street2 Address
            </label>
            <kendo-textbox class="form-control" formControlName="billingStreet2Address"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidStreet2Address && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              City <span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="billingCity"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidCity && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>

          <div class="form-group">
            <label class="lblCls">
              State<span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="billingState"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidState && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              County
            </label>
            <kendo-textbox class="form-control" formControlName="billingCounty"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidCounty && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              Country<span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="billingCountry"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidCountry && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              ZipCode<span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="billingZipCode"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidZipCode && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()"></kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              Company Phone Number<span class="requiredField">*</span>
            </label>
            <div class="input-wrapper">
              <kendo-numerictextbox class="form-control form-control-numeric" formControlName="billingPhoneNumber" [decimals]="0"
                                    [format]="'#'" [spinners]="false" [stopWheel]="true"
                                    [ngClass]="{'borderRed':newUserDialog.isInvalidBillingPhoneNumber && newUserDialog.isSubmitted}"
                                    maxlength="10" (blur)="validateNewUserForm()"></kendo-numerictextbox>
              <span title="{{newUserTxt.invalidPhoneLbl?newUserTxt.invalidPhoneLbl:newUserDialog.invalidPhoneLbl}}"
                    *ngIf="newUserDialog.isInvalidBillingPhoneNumberMessage" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls" style="margin-left:-5.5px"></span>
            </div>
            </div>
          </div>
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label class="lblCls">
            {{newUserTxt.emailLbl?newUserTxt.emailLbl:newUserDialog.emailLbl}}<span class="requiredField">*</span>
          </label>
          <div class="input-wrapper">
            <kendo-textbox class="form-control" formControlName="email"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidEmail}"
                           (blur)="emailLeave()"></kendo-textbox>

            <span title="{{newUserTxt.invalidEmailLbl?newUserTxt.invalidEmailLbl:newUserDialog.invalidEmailLbl}}" *ngIf="newUserDialog.isEmailFormatInValid" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls" style="margin-left:-5.5px"></span>
            </div>
          </div>
        <div class="form-group">
          <label class="lblCls">
            {{newUserTxt.confirmEmailLbl?newUserTxt.confirmEmailLbl:newUserDialog.confirmEmailLbl}}<span class="requiredField" >*</span>
          </label>
          <div class="input-wrapper">
            <kendo-textbox class="form-control" formControlName="confirmEmail"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidConfirmEmail}"
                           (blur)="confirmEmailLeave()"></kendo-textbox>

            <span title="{{newUserTxt.confirmEmailMatchLbl?newUserTxt.confirmEmailMatchLbl:newUserDialog.confirmEmailMatchLbl}}" *ngIf="newUserDialog.isemailNotMatched" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls" style="margin-left:-5.5px"></span>
            </div>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{newUserTxt.companyNameLbl?newUserTxt.companyNameLbl:newUserDialog.companyNameLbl}}<span class="requiredField">*</span>
            </label>
            <kendo-textbox class="form-control" formControlName="companyName"
                           [ngClass]="{'borderRed':newUserDialog.isInvalidCompanyName && newUserDialog.isSubmitted}"
                           (blur)="validateNewUserForm()" [maxlength]="maxlength" (valueChange)="onValueChangeCompanyName($event)">
              <ng-template kendoTextBoxSuffixTemplate>
                <span class="suffix">{{ counter }}</span>
              </ng-template>
            </kendo-textbox>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{newUserTxt.companyAccNumberLbl?newUserTxt.companyAccNumberLbl:newUserDialog.companyAccNumberLbl}}<span class="requiredField">*</span>
            </label>
            <div class="input-wrapper">
              <kendo-numerictextbox class="form-control  form-control-numeric" formControlName="companyAccNumber" [decimals]="0"
                                    [format]="'#'" [spinners]="false" [stopWheel]="true"
                                    [ngClass]="{'borderRed':newUserDialog.isInvalidCompanyAccNumber && newUserDialog.isSubmitted}"
                                    (blur)="validateNewUserForm()"></kendo-numerictextbox>
              <span class="k-icon k-i-info" id="icon_move" kendoTooltip title="{{newUserDialog.companyAccNumTooltip}}"></span>
            </div>
          </div>
          <br><br>
          <div class="form-group">
            <!-- <label>By Selecting either of the options,you will be required to submit approval from the company Manager/Owner </label> -->
            <label>If YES is selected, we will contact your company leadership to request required written approval.</label>
          </div>
          <div class="form-group">
            <label class="lbl switch-labels">Does this account require visibility of account summary?</label>
            <kendo-switch name="isActive" formControlName="requireAccountSummary" [onLabel]="'Yes'" [offLabel]="'No'">
            </kendo-switch>

          </div>
          <!--<div class="form-group">
    <label class="lbl switch-labels">Does this account require visibility of Invoice Details?</label>
    <kendo-switch name="isActive" formControlName="requireInvoiceDetails" [onLabel]="'Yes'" [offLabel]="'No'">
    </kendo-switch>

  </div>-->

        </div>
    </div>
    <div>
      <kendo-dialog title="Registration" *ngIf="saveInProcess" (close)="close('cancel')" [minWidth]="250" [width]="450">
        {{statusMsg}}
        <kendo-dialog-actions>
          <div style="align-content:center; margin-left:40%;">
            <button kendoButton (click)="navigate()">
              Okay
            </button>
          </div>
        </kendo-dialog-actions>
       </kendo-dialog> 
    </div>
    <!-- <div *ngIf="showStatus">
      {{statusMsg}}
    </div> -->
    <div class="row btndiv">
      <div class="col-sm-12">
        <div class="btn-group" role="group">
          <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                  (click)="registerUser()">
            {{newUserTxt.registerLbl?newUserTxt.registerLbl:newUserDialog.registerLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
          </button>
          <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                  (click)="resetNewUserForm()">
            {{newUserTxt.resetLbl?newUserTxt.resetLbl:newUserDialog.resetLbl}}
          </button> &nbsp;&nbsp;
        </div>
      </div>
    </div>
  </form>
</div>



